/*
  TEMPHOR - Vidro transparente (Clear) com refração nas bordas.
  Age nos elementos com a classe th-glass-clear e o atributo data-lg-scale
  (intensidade da curvatura). data-lg-blur define o desfoque (padrão 0,6px).
  Só no Chrome/Edge/Android (motores Chromium aplicam filtro SVG no backdrop-filter);
  nos outros navegadores fica o vidro levemente fosco definido no CSS.
*/
(function () {
  if (window.__temphorLiquidGlass) return;
  window.__temphorLiquidGlass = true;

  var brands = navigator.userAgentData && navigator.userAgentData.brands;
  var chromium = !!brands && brands.some(function (b) { return /Chromium/.test(b.brand); });
  if (!chromium || matchMedia('(prefers-reduced-transparency: reduce)').matches) return;

  var NS = 'http://www.w3.org/2000/svg';
  var count = 0;
  var defs;

  function ensureDefs() {
    if (defs) return defs;
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'absolute';
    defs = document.createElementNS(NS, 'defs');
    svg.appendChild(defs);
    document.body.appendChild(svg);
    return defs;
  }

  // Mapa de deslocamento: neutro no centro, puxa a imagem de dentro para fora perto da borda
  function displacementMap(w, h, radius, bezel) {
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    var img = ctx.createImageData(w, h);
    var d = img.data;
    var hw = w / 2;
    var hh = h / 2;
    var r = Math.min(radius, hw, hh);

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var px = x + 0.5 - hw;
        var py = y + 0.5 - hh;
        var qx = Math.abs(px) - (hw - r);
        var qy = Math.abs(py) - (hh - r);
        var sdf = Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) + Math.min(Math.max(qx, qy), 0) - r;
        var dist = -sdf; // distância até a borda, positiva dentro da forma
        var nx = 0;
        var ny = 0;
        var s = 0;
        if (dist > 0 && dist < bezel) {
          if (qx > 0 && qy > 0) {
            var len = Math.hypot(qx, qy) || 1;
            nx = (qx / len) * Math.sign(px);
            ny = (qy / len) * Math.sign(py);
          } else if (qx > qy) {
            nx = Math.sign(px);
          } else {
            ny = Math.sign(py);
          }
          var t = 1 - dist / bezel;
          s = t * t;
        }
        var i = (y * w + x) * 4;
        d[i] = 128 - nx * s * 127;
        d[i + 1] = 128 - ny * s * 127;
        d[i + 2] = 128;
        d[i + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    return canvas.toDataURL();
  }

  function build(el) {
    var rect = el.getBoundingClientRect();
    var w = Math.round(rect.width);
    var h = Math.round(rect.height);
    if (!w || !h) return;
    var radius = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
    var scale = parseFloat(el.dataset.lgScale || '20');
    var bezel = Math.max(6, Math.min(w, h) * 0.32);

    var filter = el._lgFilter;
    if (!filter) {
      filter = document.createElementNS(NS, 'filter');
      filter.id = 'th-lg-' + ++count;
      filter.setAttribute('x', '0');
      filter.setAttribute('y', '0');
      filter.setAttribute('width', '100%');
      filter.setAttribute('height', '100%');
      filter.setAttribute('primitiveUnits', 'userSpaceOnUse');
      filter.setAttribute('color-interpolation-filters', 'sRGB');
      var map = document.createElementNS(NS, 'feImage');
      map.setAttribute('x', '0');
      map.setAttribute('y', '0');
      map.setAttribute('preserveAspectRatio', 'none');
      map.setAttribute('result', 'map');
      var disp = document.createElementNS(NS, 'feDisplacementMap');
      disp.setAttribute('in', 'SourceGraphic');
      disp.setAttribute('in2', 'map');
      disp.setAttribute('xChannelSelector', 'R');
      disp.setAttribute('yChannelSelector', 'G');
      filter.appendChild(map);
      filter.appendChild(disp);
      ensureDefs().appendChild(filter);
      el._lgFilter = filter;
    }

    filter.children[0].setAttribute('width', w);
    filter.children[0].setAttribute('height', h);
    filter.children[0].setAttribute('href', displacementMap(w, h, radius, bezel));
    filter.children[1].setAttribute('scale', scale);
    var blur = parseFloat(el.dataset.lgBlur || '0.6');
    el.style.backdropFilter = 'url(#' + filter.id + ') blur(' + blur + 'px) saturate(160%) brightness(1.05)';
  }

  function init() {
    var els = document.querySelectorAll('.th-glass-clear[data-lg-scale]');
    if (!els.length) return;
    document.documentElement.classList.add('lg-refract');
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) { build(e.target); });
    });
    els.forEach(function (el) {
      build(el);
      ro.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
